export const ApiStatusTypeEnum = {
  SUCCESS: 0,
  COMMON_ERROR: 1,
  SESSION_LOST: -99,
};
